// Legacy form configs lay fields out on the 12-column grid the three legacy
// renderers provide (`grid grid-cols-12`), by putting a `col-span-*` in the
// control's className. A field that names no span would take the grid's
// default single column — a twelfth of the row — so the span is supplied here
// rather than repeated across every config entry.
//
// This replaced `legacyColClass`, which translated Bootstrap's `col-N` tokens
// at runtime. The configs now carry Tailwind's own `col-span-N`, so there is
// nothing left to translate and the JIT can see the classes in source (the
// safelist that existed for the runtime-built ones is gone with it).
export function gridSpanClass(className) {
  const tokens = (className || '').split(/\s+/).filter(Boolean);
  if (!tokens.some((t) => /(^|:)col-span-/.test(t))) tokens.push('col-span-12');
  return tokens.join(' ');
}
